import { render, staticRenderFns } from "./DetalleCompras.vue?vue&type=template&id=6068aa74"
import script from "./DetalleCompras.vue?vue&type=script&lang=js"
export * from "./DetalleCompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports